import {SpacingLarge, SpacingXsmall} from '@/componentLibrary/tokens/variables';
import styled from 'styled-components';
import {InputProps} from './types';

export const Wrapper = styled.div<InputProps>`
    margin-bottom: ${({$smallMargin}) => ($smallMargin ? SpacingXsmall : SpacingLarge)};
`;
